stimulusApp.register(
  "search--summary",
  class extends Stimulus.Controller {
    static outlets = ["search-map-toggle"]

    change() {
      if (document.body.classList.contains("google-maps-open")) {
        this.searchMapToggleOutlet.toggle()
      } else {
        Viewport.scrollTo($(".header"))
      }
    }
  },
)
